<template>
<div class="login">
	<div class="header-box">
		<div class="header-inner">
			<h1>蓝代斯克智慧基础设施平台</h1>
		</div>
	</div>

    <div class="log-email position-relative">
    	<h3>注册新用户</h3>
    	<p class="log_warn" v-if="ifwarn" v-text="warntxt"></p>
    	<input placeholder="手机号" v-model="username" class="log-input log-input-empty" />
    	<input placeholder="真实姓名" v-model="real_name" class="log-input log-input-empty" />
    	<div class="relative-box">
    		<input placeholder="验证码" v-model="code" class="log-input log-input-empty" />
    		<!--<a href="javascript:;" class="getcode" @click="getcode()">获取验证码</a>-->
    		
			<el-button @click="getcode" class="getcode" type="primary" :disabled="isDisabled">{{buttonName}}</el-button>
    	</div>
    	<input placeholder="密码" type="password" v-model="newPass" class="log-input log-input-empty" />
    	<input placeholder="确认密码" type="password" v-model="comfirNewPass" class="log-input log-input-empty" />
    	
        <a href="javascript:;" class="log-btn" @click="registerNew()">注册</a>
        <router-link class="text2" to="/login">老朋友了？点击登录</router-link>
    </div>
    <el-dialog
      width="30%"
      class="text-center"
      @close="closeDialog()"
      title="提示"
      :visible.sync="innerUpPass"
      append-to-body>
	  <span>{{innerUpPassText}}</span>
    </el-dialog>
</div>
	
</template>

<script>
	let sha256=require("js-sha256").sha256;
	export default {
		mounted(){
		  	this.$nextTick(function(){
		  		
		  		
		  	})
		},
		data() {
		  	return {
		  		innerUpPassText:"",
		  		innerUpPass:false,
		  		username:"",
		  		real_name:"",
		  		newPass:'',
		  		comfirNewPass:'',
		  		code:"",
		  		ifwarn:false,
		  		warntxt:'',
		  		buttonName: "发送短信",
				isDisabled: false,
				time: 60
		  	}
		},
		methods:{
			
			getcode(){
				this.ifwarn = false;
				this.warntxt = '';
				var reg=11 && /^(1\d{10})$/;
				if(this.username==""){
					this.ifwarn = true;
					this.warntxt = '手机号不能为空';
				}
				else if(!reg.test(this.username)){
					this.ifwarn = true;
					this.warntxt = '请输入正确的手机号码';
				}
				else{
					this.sendMsg();
					let getcodeParams={
			  			username:this.username,
			  		};
			  		this.$ajax.post(this.$store.state.domain+"/Home/SendRigster/SendRigster",this.$qs.stringify(getcodeParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		//console.log("验证码发送成功");
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			        	}else{
			        		//console.log(res.data.msg);
			        		this.ifwarn = true;
			        		this.warntxt = res.data.msg;
			        	}
			  		});
				}
				
			},
			registerNew(){
				this.ifwarn = false;
				this.warntxt = '';
				if(this.code==""){
					this.ifwarn = true;
					this.warntxt = '请输入验证码';
				}
				else if(this.newPass==this.comfirNewPass && this.newPass!=''){

					let setNewPassParams={
			  			username:this.username,
			  			real_name:this.real_name,
			  			password:sha256(this.newPass),
			  			code:this.code
			  		};
			  		this.$ajax.post(this.$store.state.domain+"/Home/Register/register",this.$qs.stringify(setNewPassParams),{
			            emulateJSON: true
			        }).then(res=>{
			        	if(res.data.status==1){
			        		//console.log("验证码发送成功");
			        		this.innerUpPassText = "注册成功，关闭弹窗进入登录页面";
							this.innerUpPass = true;
			        		
			        	}else if(res.data.code==10008){
			        		this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo);
			        	}else{
			        		//console.log(res.data.msg);
			        		this.ifwarn = true;
			        		this.warntxt = res.data.msg;
			        	}
			  		});
				}
				else{
					this.ifwarn = true;
					this.warntxt = '确认新密码要和新密码一致';
				}
				
			},
			closeDialog(){
				this.$router.push('/login');
			}
			
		}
	}
</script>

<style scoped>
	.login{
		min-height: 0;
		width: 415px;
		padding-bottom: 20px;
		height: 520px;
	}
	.log-bg{
		height: 120px;
	}
	.log-logo{
		margin-top: 20px;
		margin-bottom: 0px;
		height: 60px;
	}
	.log-email h3{
		margin-top: 50px;
		margin-bottom: 30px;
	}
	.log_warn{
		position: absolute;
		top: 85px;
		left: 0;
	}
</style>


// WEBPACK FOOTER //
// src/components/register.vue